import { FilterGroup } from '../Tools/FilterGroup';
import { NameFilter } from '../Filters/NameFilter';
import { ObjectTypeFilter } from '../Filters/ObjectTypeFilter';
import { ColorFilter } from '../Filters/ColorFilter';
import { ShowPriorityFilter } from '../Filters/ShowPriorityFilter';
import { ShowUnavailableFilter } from '../Filters/ShowUnavailableFilter';
import { ShowRSEFilter } from '../Filters/ShowRSEFilter';
import { ShowContentFactoryFilter } from '../Filters/ShowContentFactoryFilter';
import { ShowNewObjectsFilter } from '../Filters/ShowNewObjectsFilter';
import { UniversesFilter } from '../Filters/UniversesFilter';
import { PriceRangeFilter } from '../Filters/PriceRangeFilter';
import { WidthRangeFilter } from '../Filters/WidthRangeFilter';
import { FiltersWidget } from '../FiltersWidget';
import { IFilter } from '../Tools/IFilter';
import { FiltersController } from '../Tools/FiltersController';
import { ObjectStyleMDMFilter } from '../Filters/ObjectStyleMDMFilter';


export class AssetsFilterContentFactoryWidget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'assets';
        this.name = 'Objets';
        this.icon = 'fas fa-lg fa-cube';
        this.resource = 'products';
        this.showPriority = 'MDM';
        this.universes = {
            indoor: FiltersWidget.deliverable && FiltersWidget.deliverable.room_type !== 59 ? true : false,
            bathroom: false,
            outdoor: FiltersWidget.deliverable && FiltersWidget.deliverable.room_type === 59 ? true : false,
            junior: false,
            B2B: FilterGroup.mdmBusiness
        };
        this.minWidth = 0;
        this.maxWidth = 5000;

        this.minPrice = 0;
        this.maxPrice = 5000;
        this.filtersFunction = 'updateFilters';
        this.filters = [
            new NameFilter(this),
            new ObjectTypeFilter(this),
            new ObjectStyleMDMFilter(this),
            new ColorFilter(this),
            new ShowPriorityFilter(this, false),
            new ShowUnavailableFilter(this, true, false, 4),
            new ShowRSEFilter(this, false, false, 4),
            new ShowContentFactoryFilter(this, false, false, 4),
            new ShowNewObjectsFilter(this, false, true, 4),
            new UniversesFilter(this),
            new PriceRangeFilter(this),
            new WidthRangeFilter(this),
        ];

        this.filtersHtml = () => {
            let AssetsFilterWidgetHtml = '';
            let showHtml = '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">';
            let universesHtml = '';
            let rangeHtml = '';
            this.filters.forEach((filter: IFilter) => {
                if (filter.type.toLowerCase().search('show') !== -1
                    && filter.type.toLowerCase() !== 'showpriority') {
                    showHtml += `${filter.html()}`;
                } else if (filter.type.toLowerCase() === 'universes') {
                    universesHtml += `${filter.html()}`;
                } else if (filter.type.toLowerCase().search('range') !== -1) {
                    rangeHtml += `${filter.html()}`;
                } else {
                    AssetsFilterWidgetHtml += `${filter.html()}`;
                }
            });
            showHtml += '</div>';
            AssetsFilterWidgetHtml += showHtml + universesHtml + rangeHtml;
            return AssetsFilterWidgetHtml;
        }
        this.container = container;
        this.controller = new FiltersController();
    }

    generateSortString() {
        let sort: any[] = [];
        let sortString = '';

        if (FilterGroup.filters.useColorSearch) {
            return(sortString);
        } 

        if (!FilterGroup.smartSearch()) {
            if (FilterGroup.filters.universes) {
                if (!FilterGroup.filters.universes.indoor && !FilterGroup.filters.universes.bathroom && !FilterGroup.filters.universes.outdoor && !FilterGroup.filters.universes.junior && FilterGroup.filters.showPriority === 'PLACEHOLDERS') {
                    sort.push('-universes.indoor');
                    sort.push('-universes.bathroom');
                    sort.push('-universes.outdoor');
                    sort.push('-universes.junior');
                }
            }

            if (FilterGroup.filters.sort && FilterGroup.filters.sort.width) {
                if (FilterGroup.filters.sort.width === 1) {
                    sort.push('dimensions.width');
                } else {
                    sort.push('-dimensions.width');
                }
            }

            if (FilterGroup.filters.sort && FilterGroup.filters.sort.price) {
                if (FilterGroup.filters.sort.price === 1) {
                    sort.push('price.value');
                } else {
                    sort.push('-price.value');
                }
            }
        }

        if (sort.length > 0) {
            sortString += '&sort=' + sort.join(',');
        }

        return(sortString);
    }

    generateStringFilter() {
        let stringFilters = '&q.pipeline.modelState.eq=validated&q.pipeline.unrealState.eq=ready';
        let filters = FilterGroup.filters;

        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&q.kind.eq=Arrangement';
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price! > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&q.kind.eq=Arrangement';
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price! > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        this.filters.forEach((filter: IFilter) => {
            stringFilters += filter.generateStringFilter();
        });

        if (!filters.showUnavailable && filters.showPriority !== 'GENERIC' && filters.showPriority !== 'PLACEHOLDERS') {
            stringFilters += '&forecastDate=' + FilterGroup.getSupplyForcastedDate();
        }

        stringFilters += this.generateSortString();

        return stringFilters;
    };

    destroy(): void {
        super.destroy();
    }
}
